'use strict'

import objectFitImages from 'object-fit-images'

export class App {
  constructor() {
    this.headerLogo = document.getElementById('js-header-logo')
    this.header = document.getElementById('js-header')
    this.navBtn = document.getElementById('js-navbtn')
    this.nav = document.getElementById('js-nav')
    this.anchor = document.querySelectorAll('a[href^="#anc"]')
    this.scrollTop = window.pageYOffset;
    this.scrollBtm = this.scrollTop + window.innerHeight
    this.init()
    this.addEvent();
  }

  init() {
    objectFitImages('.ofi')

    if (window.navigator.userAgent.toLowerCase().indexOf('trident/7') !== -1 || (window.NodeList && !NodeList.prototype.forEach)) {
      NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }

  }

  addEvent() {
    this.navBtn.addEventListener('click', () => {
      this.headerLogo.classList.toggle('white')
      this.navBtn.classList.toggle('act');
      this.nav.classList.toggle('show');
    });

    this.anchor.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault()
        const target = document.querySelector(e.currentTarget.getAttribute('href'))
        this.smoothScroll(target, 500, 0)
        if (this.nav.classList.contains('show')) {
          this.navBtn.click()
        }
      })
    })
  }

  smoothScroll(target, duration, dis) {
    const scrollElm = (() => {
      if ('scrollingElement' in document) return document.scrollingElement
      if (navigator.userAgent.indexOf('WebKit') != -1) return document.body
      return document.documentElement
    })()
    const easing = (t,a,n,o) => {return 0==t?a:t==o?a+n:(t/=o/2)<1?n/2*Math.pow(2,10*(t-1))+a:n/2*(2-Math.pow(2,-10*--t))+a}
    const pos = target.getBoundingClientRect().top - dis
    const startTime = Date.now()
    const scrollFrom = scrollElm.scrollTop;
    (function loop() {
      const currentTime = Date.now() - startTime
      if (currentTime < duration) {
        scrollTo(0, easing(currentTime, scrollFrom, pos, duration))
        window.requestAnimationFrame(loop)
      } else {
        scrollTo(0, pos + scrollFrom)
      }
    })()
  }
}
